import { connect, mapProps } from '@formily/vue'
import OriginalCollapseItem from './CollapseItem.vue'

const CollapseItem = connect(OriginalCollapseItem, mapProps({ readOnly: 'readonly' }))

export default CollapseItem
